import { createBrowserHistory as createHistory, History } from 'history';
const history: History = createHistory();
export default history;
